import PropTypes from 'prop-types';
import cls from 'classnames';
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { isTouchScreen } from '@/api/app';
import styles from './index.module.scss';
import { isPc } from '@/utils';

const Tooltip = (props) => {
  const [display, setDisplay] = useState(false);
  const [style, setStyle] = useState({});
  const handleMouseEnter = (e) => {
    if (!isPc || isTouchScreen()) {
      return;
    }
    const { left, top, right, width, height } = e.target.getBoundingClientRect();
    setDisplay(isPc);
    switch (props.position) {
        case 'right':
          setStyle({ left: right, top: top + (height / 2), transform: 'translate(15%, -50%)' });
          break;
        case 'left':
          setStyle({ left, top: top + (height / 2), transform: 'translate(-115%, -50%)' });
          break;
        default:
          setStyle({ left: left + (width / 2), top, transform: 'translate(-50%, -146%)' });
    }
  };
  const handleMouseLeave = () => {
    setDisplay(false);
  };

  if (isTouchScreen()) {
    return props.children;
  }

  return (
    <>
      {display && props.title && ReactDOM.createPortal((
        <div
          style={{ ...style, ...(props.style || {}) }}
          className={
            cls(styles.container, styles[props.position])
          }
        >
          <p className={styles.content}>{props.title}</p>
          <span className={styles.triangle} />
        </div>),
      document.body)}
      {React.Children.map(props.children, (child) => React.cloneElement(child, {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
      }))}
    </>
  );
};

Tooltip.propTypes = {
  style: PropTypes.object,
  position: PropTypes.string,
  children: PropTypes.element,
  title: PropTypes.string,
};

export default Tooltip;
